import { Component, ViewChild } from '@angular/core';
import { UserFormComponent } from '../shared/user-form/user-form.component';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.sass'],
    standalone: false
})
export class ProfileComponent {
  @ViewChild('userForm') userForm?: UserFormComponent;

  onSave() {
    this.userForm?.save();
  }
}


